import { useCallback, useState } from 'react';

const STORAGE_KEY = 'navo_invoice_settings';

const DEFAULTS = {
    showShopInfo: true,
    showCustomerPhone: true,
    showCustomerLoyaltyPoint: true,
    showSupportEmployee: true,
    showPaymentQr: true,
};

function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return { ...DEFAULTS };
        return { ...DEFAULTS, ...JSON.parse(raw) };
    } catch {
        return { ...DEFAULTS };
    }
}

function save(settings) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {}
}

export function getInvoiceSettings() {
    return load();
}

export function useInvoiceSettings() {
    const [settings, setSettings] = useState(() => load());

    const updateSettings = useCallback((next) => {
        setSettings(next);
        save(next);
    }, []);

    const resetDefaults = useCallback(() => {
        setSettings({ ...DEFAULTS });
        save({ ...DEFAULTS });
    }, []);

    return { settings, updateSettings, resetDefaults, DEFAULTS };
}
